import { useState } from 'react'
import { Link } from 'react-router-dom'
import './PageContactBudapest.scss';
import HeaderLine from '../../../components/headerLine/HeaderLine'
import ContactHamMenu from '../contactHamMenu/ContactHamMenu';
import Infobox from '../../../components/infobox/Infobox';
import { languageElements } from './PageContactBudapest-languageElements';
import LanguageElementsHandler from '../../../repository/languageElementsHandler/LanguageElementsHandler';
import useMain from '../../../common/MainContext';

export default function ContactBudapest(props) {
    const { language } = useMain();

    const languageElementsHandler = new LanguageElementsHandler(
        languageElements,
        language,
    );

    const [hamShowed, showHam] = useState(false)

    function onHamClicked() {
        showHam(!hamShowed);
    }

    const mailTo =
        <Link to='#' onClick={(e) => {
            e.preventDefault();
            window.location = `mailto: ${languageElementsHandler.get('email')}`;
        }}
        >
            {languageElementsHandler.get('email')}
        </Link>

    const infobox = <>
        <h4>{languageElementsHandler.get('title1')}</h4>
        <h4>{languageElementsHandler.get('title2')}</h4>
        <br />
        <h6>{languageElementsHandler.get('info1')}</h6>
        <h6>{languageElementsHandler.get('info2')}</h6>
        <h6>{languageElementsHandler.get('info3')}</h6>
        <br />
        <h6>{languageElementsHandler.get('info4')}</h6>
        <h6>{languageElementsHandler.get('info5')}</h6>
        <h6>{languageElementsHandler.get('info6')}{mailTo}</h6>
    </>

    return (
        <div className='page-contact-budapest fullpage'>
            <HeaderLine
                selectedPage={'contact'}
                onHamClicked={onHamClicked}
            />

            <aside>
                <ContactHamMenu
                    show={hamShowed}
                />
            </aside>
            <main>
                <Infobox
                    info={infobox}
                />
            </main>
        </div>)
}